export default {
  languageLabel: "语言",
  languageOptions: {
    en: "English",
    zh_CN: "简体中文",
    zh_TW: "繁體中文",
  },
  scannerNameLabel: "二维码扫描器名称",
  scannerNamePlaceholder: "请输入二维码扫描器名称",
  passwordLabel: "密码",
  passwordPlaceholder: "请输入密码...",
  loginButton: "登录",
  enterButton: "进入",
  toastFillFields: "请填写完整信息",
  toastLoginFailed: "登录失败",
  indexEventTitle: "2025 HowZ 台北演唱会",
  indexStatsTotal: "总记录",
  indexStatsCheckedIn: "已签到",
  indexStatsPending: "待签到",
  indexSearchPlaceholder: "搜索...",
  indexStatusFilters: {
    all: "全部",
    claimed: "已签到",
    unclaimed: "未签到",
  },
  indexTableHeaders: {
    name: "姓名",
    email: "邮箱",
    checkInTime: "签到时间",
    status: "状态",
  },
  indexEmpty: "没有找到结果。",
  indexPaginationPrev: "上一页",
  indexPaginationNext: "下一页",
  indexPaginationPage: "第",
  indexPaginationOf: "页，共",
  indexScanButton: "扫描二维码",
  indexStatusLabels: {
    claimed: "已签到",
    unclaimed: "未签到",
  },
  indexDetailTitle: "详情",
  indexDetailName: "姓名:",
  indexDetailEmail: "邮箱:",
  indexDetailCheckInTime: "签到时间:",
  indexDetailStatus: "状态:",
  indexDetailClose: "关闭",
  readerDetailItemHolder: "持有人:",
  readerDetailItemName: "商品名称:",
  readerDetailOrderItems: "商品明细:",
  readerDetailVariantDetails: "规格:",
  readerDetailEmailAddress: "邮箱地址:",
  readerDetailCheckInTime: "签到时间:",
  readerModalClose: "关闭",
};
